/**
 * `jobs.failure_reason` → what the screen shows.
 *
 * The runner writes `<category>:<ExceptionClass>:<error_id>`
 * (apps/agent-runtime/flow_agent_runtime/failure.py). The error id is
 * the handle for the matching runner log line. Other writers store a
 * bare code (`cancelled_by_user`, `checkpoint_denied`,
 * `needs_takeover:<code>`, `publish_failed: <Class>`); those are shown
 * as they are.
 */
export interface ParsedFailure {
  /** The stored reason, capped for display. */
  raw: string;
  category: string | null;
  exceptionClass: string | null;
  errorId: string | null;
}

const STRUCTURED = /^([a-z][a-z0-9_]*):([A-Za-z_][A-Za-z0-9_.]*):(err_[0-9a-f]{6,32})$/;
const MAX_RAW = 300;

export function parseFailureReason(reason: string | null | undefined): ParsedFailure | null {
  const text = (reason ?? "").trim();
  if (!text) return null;
  const raw = text.length > MAX_RAW ? `${text.slice(0, MAX_RAW)}…` : text;
  const m = STRUCTURED.exec(text);
  if (!m) return { raw, category: null, exceptionClass: null, errorId: null };
  return { raw, category: m[1] ?? null, exceptionClass: m[2] ?? null, errorId: m[3] ?? null };
}

export function categoryLabel(category: string): string {
  const text = category.replace(/_/g, " ");
  return text.charAt(0).toUpperCase() + text.slice(1);
}
